import {IModalServiceInstance} from 'angular-ui-bootstrap';
import ITranslateService = angular.translate.ITranslateService;
import ILogService = angular.ILogService;

export class MapController {

    static $inject = ['$uibModalInstance', '$translate', 'lat', 'lon', 'reado', '$log'];

    constructor(private $uibModalInstance: IModalServiceInstance, $translate: ITranslateService, private lat: string, private lon: string,
                private reado: boolean, private $log: ILogService) {
        if (!lat) {
            lat = '';
        }
        if (!lon) {
            lon = '';
        }
    }

    ok(): void {
        this.$uibModalInstance.close({lat: this.lat, lon: this.lon});
    };

    cancel(): void {
        this.$uibModalInstance.dismiss('cancel');
    };

    public positionChanged(lon: string, lat: string): void {
        this.lat = lat;
        this.lon = lon;

    }

}



// WEBPACK FOOTER //
// ./src/app/core/dialog/MapController.ts